import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    username,
    act = 'check',
    verCodeId,
    verifyCode,
    password,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.user.resetPassword, {
        username,
        act,
        verCodeId,
        verifyCode,
        password,
    }, options);
    if (error) return { error, status };
    return content || {};
};

